<script lang="ts">
    import type { ZoomRangeWithBlocks } from "../zoom2.svelte.js";

    type Props = {
        currentZoom: ZoomRangeWithBlocks;
        rowLineHeight: number;
    };
    let { currentZoom, rowLineHeight }: Props = $props();
</script>

<div
    class="blocks"
    style:--cell-width={`${currentZoom.cellPx}px`}
    style:--row-line-height={`${rowLineHeight}px`}
>
    {#each currentZoom.blocks as block}
        <div class="block">
            <div class="block-heading">
                <p class="block-label">{block.label}</p>
            </div>
            <div class="cells">
                {#each block.cells as cell, _}
                    <div class="cell">
                        <p>{cell.label}</p>
                    </div>
                {/each}
            </div>
        </div>
    {/each}
</div>

<style lang="scss">
    .blocks {
        grid-area: 1 / 1 / 2 / 2;
        display: flex;
        height: fit-content;
        color: var(--clr-on-surface-1);
        background: var(--clr-surface-0);
        box-shadow: 0 0 0.5rem 0 #00000070;
    }
    .block {
        position: relative;
        height: fit-content;
    }
    .block-heading {
        border: solid 1px #444;
        border-top-width: 0;
        border-right-width: 0;
        display: flex;
        justify-content: center;
    }
    .block-label {
        width: max-content;
        position: sticky;
        left: 0;
        right: 0;
        padding: 0.25rem 0.5rem;
    }
    .cell {
        border-left: solid 1px #444;
        border-bottom: solid 1px #444;
        width: var(--cell-width);
        position: relative;
        padding: 0 0.5rem;
        &:nth-child(odd) {
            background: #00000008;
        }
        p {
            text-align: center;
        }
    }
    .cells {
        display: flex;
    }
</style>
